import React from 'react';
import { Icon } from './Icon.js';
export const IconPositionBottomLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "9", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "2.75", cy: "2.75", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "5.875", cy: "2.75", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "2.75", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "12.125", cy: "2.75", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "12.125", cy: "15.25", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "15.25", cy: "2.75", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "15.25", cy: "5.875", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "2.75", cy: "5.875", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "15.25", cy: "9", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "15.25", cy: "12.125", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "15.25", cy: "15.25", r: ".75", fill: "currentColor" })));
};
//# sourceMappingURL=IconPositionBottomLeftFill18.js.map